import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import type { IProfesor } from 'models/profesor_model';
import {
  allProfesorsRepository,
  createProfesorRepository,
} from 'repositories/profesor';

interface ProfesorState {
  profesors: IProfesor[];
  loading: boolean;
  error: string | null;
}

const initialState: ProfesorState = {
  profesors: [],
  loading: false,
  error: null,
};

export const cargarProfesores = createAsyncThunk<IProfesor[], boolean | undefined, { rejectValue: string }>(
  'profesor/cargarProfesores',
  async (isKinder = undefined, { rejectWithValue }) => {
    try {
      return ((await allProfesorsRepository(isKinder)) ?? []) as IProfesor[];
    } catch {
      return rejectWithValue('Error al cargar profesores');
    }
  },
);

export const addProfesor = createAsyncThunk(
  'profesor/addProfesor',
  async ({ nombre, ci }: { nombre: string; ci: string }, { rejectWithValue }) => {
    try {
      await createProfesorRepository({ nombre, ci });
    } catch {
      return rejectWithValue('Error al crear profesor');
    }
  },
);

export const profesorSlice = createSlice({
  name: 'profesor',
  initialState,
  reducers: {
    setProfesores: (state, action: PayloadAction<IProfesor[]>) => {
      state.profesors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cargarProfesores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cargarProfesores.fulfilled, (state, action) => {
        state.loading = false;
        state.profesors = action.payload;
      })
      .addCase(cargarProfesores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setProfesores } = profesorSlice.actions;
export default profesorSlice.reducer;
